import { Pathnames } from "next-intl/routing";

/**
 * Phased Multilingual Rollout Strategy
 * =====================================
 * To avoid Google spam detection, we're rolling out languages in phases:
 * 
 * Phase 1 (Current): Top 5 high-value languages
 * Phase 2 (Week 2): + European languages (de, es, it, pt, nl, pl)
 * Phase 3 (Week 3): + Asian languages (zh-TW, vi, th, id, ms, ar)
 * Phase 4 (Week 4): + Remaining languages
 */

// ============================================
// PHASE 1: Top 5 High-Value Languages + Traditional Chinese (ACTIVE)
// ============================================
export const locales = [
  "en",      // English - Global default
  "ja",      // Japanese - High purchasing power
  "vi",      // Vietnamese - Fast-growing market
  // "zh-CN",   // Simplified Chinese - Largest market
  // "zh-TW",   // Traditional Chinese
  // "ko",      // Korean - Tech-savvy users
  // "fr",      // French - European gateway
];

// ============================================
// ALL LANGUAGES (for reference & future phases)
// Uncomment sections as you progress through phases
// ============================================
// Phase 2 additions:
// "de", "es", "it", "pt", "nl", "pl",
// Phase 3 additions:
// "vi", "th", "id", "ms", "ar", "ru", "tr",
// Phase 4 additions:
// "hi", "bn", "he", "ur", "fa", "mr", "ta", "te", "ne", "da", "fi", "no", "sv",

// Active locale display names (only enabled languages)
export const localeNames: Record<string, string> = {
  "en": "English",
  "ja": "日本語",
  "vi": "Tiếng Việt",
  "zh-CN": "简体中文",
  "zh-TW": "繁體中文",
  "ko": "한국어",
  "fr": "Français",
};

// Full locale names map (keep for future phases)
export const allLocaleNames: Record<string, string> = {
  "en": "English",
  "zh-CN": "简体中文",
  "zh-TW": "繁體中文",
  "ja": "日本語",
  "ko": "한국어",
  "de": "Deutsch",
  "fr": "Français",
  "it": "Italiano",
  "es": "Español",
  "pt": "Português",
  "hi": "हिन्दी",
  "ar": "العربية",
  "bn": "বাংলা",
  "id": "Bahasa Indonesia",
  "ms": "Bahasa Melayu",
  "th": "ภาษาไทย",
  "he": "עברית",
  "ru": "Русский",
  "ur": "اردو",
  "tr": "Türkçe",
  "vi": "Tiếng Việt",
  "fa": "فارسی",
  "mr": "मराठी",
  "ta": "தமிழ்",
  "pl": "Polski",
  "te": "తెలుగు",
  "ne": "नेपाली",
  "da": "Dansk",
  "fi": "Suomi",
  "nl": "Nederlands",
  "no": "Norsk",
  "sv": "Svenska",
};

export const defaultLocale = "en";

export const localePrefix = "always";

export const localeDetection =
  process.env.NEXT_PUBLIC_LOCALE_DETECTION === "true";
